import { render, staticRenderFns } from "./BusinessFilesPop.vue?vue&type=template&id=ee0cea66"
import script from "./BusinessFilesPop.vue?vue&type=script&lang=js"
export * from "./BusinessFilesPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee0cea66')) {
      api.createRecord('ee0cea66', component.options)
    } else {
      api.reload('ee0cea66', component.options)
    }
    module.hot.accept("./BusinessFilesPop.vue?vue&type=template&id=ee0cea66", function () {
      api.rerender('ee0cea66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/BusinessFilesPop.vue"
export default component.exports